import { NamePath } from 'antd/es/form/interface'
import { AvailableLocale } from '../../models/Lang'

const computeFormItemName = (
  namePrefix: NamePath,
  name: NamePath,
  lang: AvailableLocale
): NamePath => [
  ...(namePrefix ?? []),
  lang,
  ...(Array.isArray(name) ? name : [name]),
]

export { computeFormItemName }
